"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _InteractionWithNavigationConfirmationComponentConfig = _interopRequireDefault(require("customer-data-communicator/schema/wrappers/InteractionWithNavigationConfirmationComponentConfig"));

var _default = (0, _InteractionWithNavigationConfirmationComponentConfig.default)({
  abandonChangesPromptKey: 'customerDataCommunicator.InteractionWithNavigationConfirmation.abandonChanges.emailPrompt'
});

exports.default = _default;
module.exports = exports.default;